import moment from 'moment'
import React from 'react'
import DatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Text from 'react-text'
import * as dateLocale from 'date-fns/locale'
import {Consumer} from '../../../context'
import "react-datepicker/dist/react-datepicker.css"
import './index.styl'

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        {this.props.value}
      </div>
    )
  }
}

export default function DateStep(props) {

  const setMessage = event => props.setState({message: event.target.value})
  const hours = Math.floor(props.maxTime / 3600)
  const minutes = props.maxTime % 3600 / 60
  const setHours = event => {
    const value = parseInt(event.target.value) 
    const hours = isNaN(value) ? 0 : value
    const maxTime = minutes * 60 + hours * 3600
    props.setState({maxTime})
  }
  const setMinutes = event => {
    const value = parseInt(event.target.value) 
    const minutes = isNaN(value) ? 0 : value
    const maxTime = minutes * 60 + hours * 3600
    props.setState({maxTime})
  }

  return (<Consumer>{ context => {
    
    return (
      <div className="date-step">
        <div className="instructions">
          <Text id='schedule_lesson_date_instructions' />
        </div>
        <div className="content">
          <div className="date">
            <label><Text id="date_label" /></label>
            <div className="inputs">
              <div className="from">
                <DatePicker
                customInput={<DateInput />}
                locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
                selected={moment(props.start).toDate()}
                minDate={new Date()}
                maxDate={moment().add(1,'year').toDate()}
                showTimeInput
                dateFormat="MM/dd/yyyy h:mm aa"
                onChange={start => {
                const finish = moment(props.finish).isAfter(start)
                ? props.finish
                : moment(start).toDate()
                props.setState({start, finish})
                }}
                />
              </div>
              <div className="separator"><div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>-</div></div>
              <div className="to">
                <DatePicker
                customInput={<DateInput />}
                locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
                selected={moment(props.finish).toDate()}
                minDate={moment(props.start).toDate()}
                maxDate={moment().add(1,'year').toDate()}
                showTimeInput
                dateFormat="MM/dd/yyyy h:mm aa"
                timeIntervals={60}
                onChange={finish => {
                props.setState({finish})
                }}
                />
              </div>
            </div>
          </div>
        <div className="duration">
          <div className="hours">
            <label><Text id="hours" /></label>
            <div className="inputs">
              <input type="text" value={hours} onChange={setHours} />
            </div>
          </div>
          <div className="separator"><div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}> </div></div>
          <div className="minutes">
            <label><Text id="minutes" /></label>
            <div className="inputs">
              <input type="text" value={minutes} onChange={setMinutes} />
            </div>
          </div>
        </div>
        <div className="message">
          <div className="label">
            <Text id='message_label' />
          </div>
          <div className="value">
            <textarea
              placeholder={context.translate('schedule_lesson_date_message_placeholder')}
              value={props.message}
              onChange={setMessage}
            />
          </div>
        </div>
      </div>
    </div>
  )
  }}</Consumer>)
}
